module.exports = __webpack_public_path__ + "img/1358696.75b9c119.svg";